import React from 'react'
import Smartview from 'widgets/smartviews/Smartview'
import { Translation, Translator } from '@morningtrain/react-translations'
import { Collection, ForEachModel, ToggleSelectionOnClick, WhenCollectionIsNotEmpty } from '@morningtrain/react-resources'
import * as Displays from 'support/displays'
import * as UI from 'ui'
import * as Icons from 'ui/icons'
import { MountSmartviewOnSelection } from '@morningtrain/react-smartviews'
import EditRoleSmartview from './EditRoleSmartview'
import { Pipeline, TriggerPipelineOnClick } from '@morningtrain/react-helpers'
import { NavigateOnPipe } from '@morningtrain/react-navigation'
import MountSmartviewOnClick from 'support/utilities/MountSmartviewOnClick'

export default function ManageRolesSmartview () {
  return (
    <Smartview size='lg'>
      <Translator namespace='settings.permissions.smartviews.manage_roles_smartview'>
        <UI.CardHeader>
          <UI.WithSubtitle subtitle={<Translation name='description' />}>
            <UI.SecondaryHeading>
              <Translation name='title' />
            </UI.SecondaryHeading>
          </UI.WithSubtitle>
          <UI.ButtonWrap>
            <MountSmartviewOnClick smartview={<EditRoleSmartview create />} replace={false}>
              <UI.Button>
                <Translation name='actions.create' />
              </UI.Button>
            </MountSmartviewOnClick>
          </UI.ButtonWrap>
        </UI.CardHeader>
        <Collection resourceName='permissions.roles'>
          <WhenCollectionIsNotEmpty>
            <MountSmartviewOnSelection smartview={<EditRoleSmartview />} replace={false} />
            <UI.VerticalList>
              <ForEachModel>
                <ToggleSelectionOnClick>
                  <UI.SpaceBetween>
                    <UI.WithSubtitle subtitle={<Displays.Text name='name' />}>
                      <Displays.Text name='translated_name' />
                    </UI.WithSubtitle>
                    <Pipeline>
                      <TriggerPipelineOnClick>
                        <UI.SquareButton color='btn-lightgray' className='p-2'>
                          <Icons.SortList />
                        </UI.SquareButton>
                      </TriggerPipelineOnClick>
                      <NavigateOnPipe route='app.settings.permissions' routeParameters={{ role: 'model:id' }} />
                    </Pipeline>
                  </UI.SpaceBetween>
                </ToggleSelectionOnClick>
              </ForEachModel>
            </UI.VerticalList>
          </WhenCollectionIsNotEmpty>
        </Collection>
      </Translator>
    </Smartview>
  )
}
